import script from "./help.vue?vue&type=script&setup=true&lang=js"
export * from "./help.vue?vue&type=script&setup=true&lang=js"

import "./help.vue?vue&type=style&index=0&id=1e13092f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e13092f"]])

export default __exports__